angular.module('wbDirectives').directive 'wbAutoSelect', ->
  scope: false
  restrict: 'A'
  require: 'ngModel'
  link: ($scope, $el, $attrs, ngModel) ->
    select = (element) ->
      value = element.val()
      length = value.length
      node = element[0]
      node.focus()
      node.setSelectionRange(0, length)

    render = ngModel.$render
    ngModel.$render = ->
      render()
      if $attrs.wbAutoSelect == '' or $scope.$eval($attrs.wbAutoSelect)
        select($el)
